var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarningRectangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 31,
    viewBox: "0 0 22 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.43a2 2 0 012-2h16a2 2 0 012 2v20.51a2 2 0 01-.893 1.665l-7.692 5.114a2 2 0 01-2.162.034l-8.307-5.154a2 2 0 01-.946-1.7V2.43z",
    fill: "#ED513C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 19.703a1.375 1.375 0 102.75 0 1.375 1.375 0 00-2.75 0zm.688-3.61h1.374a.172.172 0 00.172-.17v-9.97a.172.172 0 00-.171-.172h-1.376a.172.172 0 00-.171.172v9.97c0 .094.077.17.171.17z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "./fonts/warning-rectangle.75ca8bf33b4a8b3e15c5192ce6d99a98.svg";
export { SvgWarningRectangle as ReactComponent };